export const environment = {
  production: true,
  appTitle: 'ΕΟΠΥΥ - Άυλες Υποβολές Συνταγών',
  appSubtitle: 'Εθνικός Οργανισμός Παροχής Υπηρεσιών Υγείας',
  appTitleShort: 'ΕΟΠΥΥ - Pharmacy Validation',
  environmentName: 'production',
  ROOT_FOLDER: '',
  appUrl: 'http://ayles.dev2026.bluedotebusiness.com',
  apiUrl: 'http://ayles.dev2026.bluedotebusiness.com/Api', // TODO: Update to actual PaperlessValidation API URL when deployed
  appVersion: '0.0.1',
  useMock: false,
};
